import { Sparkles } from 'lucide-react'

export interface GeneratingImage {
  id: string
  prompt: string
}

interface Props {
  generating: GeneratingImage
}

export function GeneratingMediaPreview({ generating }: Props) {
  return (
    <div className="border-border bg-muted relative flex aspect-square flex-col items-center justify-center overflow-hidden rounded-lg border p-4">
      <div className="flex flex-col items-center gap-3">
        <div className="relative">
          <Sparkles className="text-primary h-8 w-8 animate-pulse" />
          <div className="border-primary/30 border-t-primary absolute -inset-2 animate-spin rounded-full border-2" />
        </div>
        <div className="text-center">
          <p className="text-foreground text-sm font-medium">Generating image...</p>
          <p className="text-muted-foreground mt-1 line-clamp-2 text-xs">{generating.prompt}</p>
        </div>
      </div>
    </div>
  )
}
